export enum TabViewMode {
  Notifications = 'notifications',
  Jobs = 'jobs',
}

export enum Classification {
  NotRegulatory,
  Regulatory,
}

export enum NotRegulatoryReason {
  UntrustedSource,
  UntrustedSender,
  Bounce,
  SubscriptionMessage,
}

export enum LinkStatus {
  Pending,
  CaptchaCheck,
  Downloading,
  Resolved,
  Attention,
}

export enum ProcessingStatus {
  NotAvailable,
  Queued,
  Processing,
  Attention,
  Transferring,
  Transferred,
  Failed,
}

export enum JobTrigger {
  Manual,
  System,
}

export enum JobStatus {
  NotAvailable,
  Running,
  Completed,
  CompletedWithErrors,
  Failed,
}
